export const ReportOptionsCategories = {
  Define: 'Define',
  Group: 'Group',
  Compare: 'Compare',
  Analyze: 'Analyze',
  More: 'More'
};